import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LangProvider } from '@dia/i18n';
import { shellCssVariables } from '@dia/ui/tokens';
import { App } from './App';
import { AuthProvider } from './auth';
import { registerServiceWorker } from './serviceWorker';
import { sync } from './supabase';
import './index.css';

/**
 * Boot order matters here.
 *
 *   1. the shell's tokens go in as CSS variables, before React paints, so
 *      there is one place a color is written down and no flash of the wrong one,
 *   2. the sync engine starts, which drains anything left in the outbox from
 *      the last time the app was open,
 *   3. React renders.
 *
 * The guest shell defaults to English with a Spanish toggle (Section 10).
 */
const style = document.createElement('style');
style.textContent = shellCssVariables('guest');
document.head.prepend(style);

sync.start();

// A new deploy reaches a phone that already has the app (see serviceWorker.ts).
// Missing until 2026-09-26: the guest app kept running an old service worker
// across same-day deploys, which is what a stale "OK" badge, an already-fixed
// layout bug reappearing, and a React "insertBefore" crash all had in common.
if (import.meta.env.PROD) registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LangProvider defaultLang="en" storageKey="dia.guest.lang">
      <AuthProvider>
        <App />
      </AuthProvider>
    </LangProvider>
  </StrictMode>,
);
